import React, { useState } from "react";
import api from "../lib/adminApi";
import { ArrowUpDown, X, Loader2, Check } from "lucide-react";

const PLANS = ["free", "standard", "pro", "premium"];

export default function PlanChangeModal({ tenant, onClose }) {
  const [plan, setPlan] = useState(tenant.effective_plan || "free");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setLoading(true);
    setError("");
    try {
      await api.post(`/tenants/${tenant.tenant_id}/plan`, { plan });
      setDone(true);
      setTimeout(() => onClose(), 1200);
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to change plan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm" onClick={onClose}>
      <div
        className="glass-modal w-full max-w-sm mx-4"
        onClick={(e) => e.stopPropagation()}
        data-testid="plan-change-modal"
      >
        <div className="flex items-center justify-between p-5 border-b border-[#7C5CFF]/[0.08]">
          <div className="flex items-center gap-2">
            <ArrowUpDown className="w-4 h-4 text-[#7C5CFF]" />
            <p className="font-bold text-[#0B0F1A] text-sm">Change Plan</p>
          </div>
          <button onClick={onClose} data-testid="plan-modal-close"><X className="w-4 h-4 text-[#5B617A]" /></button>
        </div>

        <div className="p-5 space-y-3">
          <p className="text-sm text-[#0B0F1A]">
            Tenant: <strong>{tenant.name}</strong>
          </p>
          <p className="text-xs text-[#5B617A]">
            Current plan: <span className="font-semibold text-[#0B0F1A]">{tenant.effective_plan}</span>
          </p>

          {error && <p className="text-red-600 text-sm bg-red-50 p-2 rounded-xl" data-testid="plan-error">{error}</p>}

          <div className="space-y-1.5">
            {PLANS.map((p) => (
              <button
                key={p}
                data-testid={`plan-option-${p}`}
                onClick={() => setPlan(p)}
                className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl border text-sm font-medium transition-colors
                  ${plan === p ? "border-[#7C5CFF] bg-[#7C5CFF]/[0.08] text-[#7C5CFF]" : "border-[#7C5CFF]/[0.12] text-[#0B0F1A] hover:bg-[#7C5CFF]/[0.04]"}`}
              >
                <span className="capitalize">{p}</span>
                {plan === p && <Check className="w-4 h-4" />}
              </button>
            ))}
          </div>

          {done ? (
            <div className="flex items-center justify-center gap-1.5 py-2 text-emerald-600 font-semibold text-sm">
              <Check className="w-4 h-4" /> Plan updated
            </div>
          ) : (
            <button
              data-testid="plan-submit"
              onClick={submit}
              disabled={loading || plan === tenant.effective_plan}
              className="w-full h-10 rounded-xl text-white font-semibold text-sm flex items-center justify-center btn-primary-glass"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : `Change to ${plan}`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
